module.exports = __webpack_public_path__ + "img/dne-international.ff32e019.png";